module.exports = __webpack_public_path__ + "img/guide01.654f1925.png";